import Resource from '@/api/resources/Resource'

/**
    * @deprecated You must use the new service that is located in "configuration/cases/caseType/configuration-case-types.service.ts"
    */
class CaseTypesConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/caseTypes`, filterModel, { params })
        return response.data
    }
    async getCaseTypesByName(params) {
        const response = await this.axios.get(`/configuration/caseTypes/search`, { params })
        return response.data
    }
    async patchCaseTypesBatch(caseTypes) {
        const response = await this.axios.patch(`/configuration/caseTypes/batch`, caseTypes)
        return response.data
    }
    async createCaseType(caseType) {
        const response = await this.axios.post(`/configuration/caseTypes`, caseType)
        return response.data
    }
    async deleteCaseTypesBatch(caseTypes) {
        const data = {
            entityIdentifiers: caseTypes
        }
        const response = await this.axios.delete(`/configuration/caseTypes/batch`, { data: data })
        return response.data
    }
}

export default new CaseTypesConfigurationServices()
